import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { StringUtil } from 'ml-portals-util-js';

import styles from '../MLClaimDetailPopup/MLClaimDetailPopup.module.scss';

import metadata from './MLVehiclesInvolvedComponent.metadata.json5';
import messages from './MLVehiclesInvolvedComponent.messages';

const EMPTY_STRING = "";


const MLVehiclesInvolvedComponent = (props) => {
    const {
        vehicles
    } = props;
    const translator = useTranslator();

    let yourCar;
    let otherCars;

    if (vehicles.length > 0) {
        yourCar = vehicles.find((vehicle) => vehicle.policyVehicle);
        otherCars = vehicles.filter((vehicle) => !vehicle.policyVehicle);
    }

    const formatVehicleDisplayName = (name) => {
        if (name === undefined) {
            return EMPTY_STRING;
        }
            
        name = name.toLowerCase();
        name = StringUtil.capitalizeFirstLetter(name);
        return name;
    };

    const getYourCarDetails = () => {
        if (_.isUndefined(yourCar)) {
            return {}
        }

        return {
            carYearandMake: {
                content: (<div style={{ fontWeight: 'bold' }}>{yourCar.year} {formatVehicleDisplayName(yourCar.make)}</div>)
            },
            carModelandTrim: {
                content: (<div>{formatVehicleDisplayName(yourCar.model)} {yourCar.trim_ML}</div>)

            },
            licensePlate: {
                content: (translator(messages.licensePlate, { license: yourCar.licensePlate }))
            },
            color: {
                content: (translator(messages.color, { color: yourCar.color }))

            },
        }
    }

    const getOtherCarsOvverides = () => {
        const otherCarOvveride = _.isUndefined(otherCars) ? [] :  otherCars.map((otherCar, index) => {
            return {
                [`otherCarYearandMake${index}`]: {
                    content: (<div style={{ fontWeight: 'bold' }}> {otherCar.year} {formatVehicleDisplayName(otherCar.make)}</div>)
                },
                [`otherCarModelandTrim${index}`]: {
                    content: (<div>{formatVehicleDisplayName(otherCar.model)} {otherCar.trim_ML}</div>)
                },
            }

        });
        return Object.assign({}, ...otherCarOvveride);
    }

    const overrideProps = {
        yourCarContainer: {
            visible: yourCar !== undefined
        },

        otherCarIterable: {
            data: otherCars
        },

        ...getYourCarDetails(),
        ...getOtherCarsOvverides()
    };
    const resolvers = {
        resolveClassNameMap: styles

    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            {...resolvers} />
    );

};

MLVehiclesInvolvedComponent.propTypes = {
    vehicles: PropTypes.arrayOf(PropTypes.object).isRequired
};


export default MLVehiclesInvolvedComponent;
